<app-wrapper [hideServices]=true>
    <div class="service-content {{store.state.common.sidemenuSmall ? 'sidemenu-small' : ''}} container-fluid h-100">
        <div class="row pt-3 px-3 w-100 m-0">
            <div class="translations col">
                <div class="translations-filters pt-3">
                    <div class="row mb-4">
                        <div class="col-xl-6 col-sm-12">
                            <div class="list-search-container">
                                <i class="fas fa-search list-search-icon"></i>
                                <input class="form-control list-search-input" type="text"
                                    placeholder="{{ 'Search for translations' | translate }}" [(ngModel)]="searchTrad"
                                    (keyup)="searchTranslations(1, selectedService)">
                                <i *ngIf="searchTrad"
                                    (click)="searchTrad = ''; loadTranslations(currentLanguage, selectedService, 1);"
                                    class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                                <toggle-switch [containerClass]="'toggle-switch-field mr-2'" [toggled]="exactMatch"
                                    (toggledChange)="setExactMatch($event)" [size]="'sm'"
                                    [label]="'Exact match' | translate"></toggle-switch>
                            </div>
                        </div>
                        <div class="col-xl-4 col-sm-12 d-flex justify-content-center">

                        </div>
                        <div class="col-xl-1 col-sm-12 d-flex">

                        </div>
                        <div class="col-xl-1 col-sm-12 d-flex justify-content-end align-items-center px-3"
                            style="padding-right: 11px !important;">
                            <div *ngIf="isTranslationManager" class="ml-auto dropdown align-self-center dropdown p-0"
                                dropdown placement="bottom-right">
                                <button class="btn btn-ghost btn-sm" dropdownToggle>
                                    <i class="fa-regular fa-ellipsis-vertical mr-2"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-left-outside" *dropdownMenu>
                                    <div class="dropdown-item px-3">
                                        <toggle-switch [toggled]="authVisibility"
                                            (toggledChange)="authVisibility = $event"
                                            [label]="'Manage translations' | translate"
                                            [iconOnClass]="'fa-toggle-large-on toggle-primary'"
                                            [iconOffClass]="'fa-toggle-large-on fa-flip-horizontal toggle-disabled'"
                                            [containerClass]="'service-context-menu-item'"></toggle-switch>
                                    </div>
                                    <div class="dropdown-divider" *ngIf="authVisibility"></div>
                                    <div class="dropdown-item px-3" *ngIf="authVisibility">
                                        <toggle-switch [toggled]="bpaProperties.localAuthorized"
                                            (toggledChange)="updateSystemProps('localAuthorized')"
                                            [label]="'Authorize local' | translate"
                                            [iconOnClass]="'fa-toggle-large-on toggle-primary' + (thirdState.localAuthorized ? ' fa-toggle-third-state' : '')"
                                            [iconOffClass]="'fa-toggle-large-on fa-flip-horizontal toggle-disabled' + (thirdState.localAuthorized ? ' fa-toggle-third-state' : '')"
                                            [containerClass]="'service-context-menu-item'"></toggle-switch>
                                    </div>
                                    <div class="dropdown-item px-3" *ngIf="authVisibility && (bpaProperties.localAuthorized || thirdState.localAuthorized)">
                                        <toggle-switch [toggled]="bpaProperties.localSupersedesGlobal"
                                            (toggledChange)="updateSystemProps('localSupersedesGlobal')"
                                            [label]="'Local supersedes Global' | translate"
                                            [iconOnClass]="'fa-toggle-large-on toggle-primary' + (thirdState.localSupersedesGlobal ? ' fa-toggle-third-state' : '')"
                                            [iconOffClass]="'fa-toggle-large-on fa-flip-horizontal toggle-disabled' + (thirdState.localSupersedesGlobal ? ' fa-toggle-third-state' : '')"
                                            [containerClass]="'service-context-menu-item'"></toggle-switch>
                                    </div>
                                    <div class="dropdown-divider" *ngIf="authVisibility"></div>
                                    <div class="dropdown-item" *ngIf="authVisibility">
                                        <a href="#" class="service-context-menu-item" (click)="reloadGlobalTranslations(); $event.preventDefault();">
                                            <span
                                                class="fad fa-sync-alt {{loadingGlobal ? 'fa-spin' : ''}}"></span>
                                            {{ 'Reload Global' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown-item" *ngIf="authVisibility">
                                        <a href="#" class="service-context-menu-item" (click)="reloadTranslationsCache(); $event.preventDefault();">
                                            <span
                                                class="fad fa-sync-alt {{loadingCache ? 'fa-spin' : ''}}"></span>
                                            {{ 'Reload Cache' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center translations-categories-filters">
                        <div class="translations-selector d-flex justify-content-between align-items-center">
                            <button
                                (click)="selectedService = 'general'; selectedFilters = 'all'; this.filters = 'BPA,DS,STATISTICS'; loadTranslations(currentLanguage, 'general', 1);"
                                type="button" class="btn btn-light {{selectedFilters === 'all' ? 'active' : ''}}">{{
                                'All' | translate }}</button>
                            <button
                                (click)="selectedService = serviceId; selectedFilters = 'service'; this.filters = 'DS'; loadTranslations(currentLanguage, serviceId, 1);"
                                type="button"
                                class="btn btn-light service-filter {{selectedFilters === 'service' ? 'active' : ''}}"><span>{{
                                    'Services' | translate }}</span></button>
                            <button
                                (click)="selectedService = 'general'; selectedFilters = 'bpa'; this.filters = 'BPA'; loadTranslations(currentLanguage, 'general', 1);"
                                type="button"
                                class="btn btn-light bpa-filter {{selectedFilters === 'bpa' ? 'active' : ''}}"><span>{{
                                    'BPA' | translate }}</span></button>
                            <button
                                (click)="selectedService = 'general'; selectedFilters = 'ds'; this.filters = 'DS'; loadTranslations(currentLanguage, 'general', 1);"
                                type="button"
                                class="btn btn-light ds-filter {{selectedFilters === 'ds' ? 'active' : ''}}"><span>{{
                                    'DS' | translate }}</span></button>
                            <button
                                (click)="selectedService = 'general'; selectedFilters = 'stats'; this.filters = 'STATISTICS'; loadTranslations(currentLanguage, serviceId, 1);"
                                type="button"
                                class="btn btn-light stats-filter {{selectedFilters === 'stats' ? 'active' : ''}}"><span>{{
                                    'Statistics' | translate }}</span></button>
                        </div>
                        <div class="translation-legend-container">
                            <div class="translation-legend"><i class="fa-solid fa-l"></i><span>{{ 'Local' | translate
                                    }}</span></div>
                            <div class="translation-legend"><i class="fa-solid fa-g"></i><span>{{ 'Global' | translate
                                    }}</span></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center translations-service-fields-filters mt-3"
                        *ngIf="selectedFilters === 'service'">
                        <div class="col-xl-6">
                            <span class="select-container translations-service-select d-inline-flex flex-grow-1 w-100">
                                <search-services
                                    class="w-100 d-inline-block {{this.selectedService === 'general' ? '' : 'first'}}"
                                    (changeValue)="this.switchServices($event)"
                                    [prependIcon]="'fa-thin fa-solar-system'" [items]="this.services"
                                    [selected]="this.serviceId" [keepSearch]="false"
                                    [placeholder]="'Select service' | translate">
                                </search-services>
                                <search-services *ngIf="this.selectedService != 'general'"
                                    class="w-100 d-inline-block {{this.selectedService === 'general' ? '' : 'last'}}"
                                    (changeValue)="this.switchForms($event)" [items]="this.serviceForms"
                                    [prependIcon]="'fa-thin fa-file-pen'" [selected]="this.formId" [keepSearch]="false"
                                    [placeholder]="'Select form' | translate">
                                </search-services>
                            </span>
                        </div>
                    </div>
                    <div class="translations-header mt-3">
                        <div class="{{authVisibility ? 'flex-3' : 'flex-4'}} py-2 header-col-translation-key">
                            {{'page.translation.code_label' | translate}}</div>
                        <div class="flex-1 py-2" *ngIf="authVisibility"></div>
                        <div class="flex-7 py-2">
                            <div class="d-flex column-gap-1">
                                <div class="flex-1 text-uppercase" *ngFor="let lnT of this.languages">{{lnT.code}}</div>
                            </div>
                        </div>
                        <div class="action-col flex-1 py-2"></div>
                    </div>
                </div>
                <div *ngIf="!this.isGlobalReady" class="row mx-2">
                    <i class="fas fa-spinner fa-spin"></i> {{ 'page.translations.loading_Global' | translate }}
                </div>

                <div class="translations-body" *ngIf="this.isTableBodyVisible">
                    <div class="translations-row {{fromTypeToClass(translation[this.languages[0].code].type)}}"
                        *ngFor="let translation of this.myTranslations?.items; let i = index">
                        <div class="{{authVisibility ? 'flex-3' : 'flex-4'}} translations-row-label align-items-center d-flex"
                            *ngIf="translation[this.languages[0].code]">
                            <span *ngIf="this.displayFieldName(translation[this.languages[0].code])">
                                {{ translation[this.languages[0].code].fieldName}}
                            </span>
                            <span *ngIf="!this.displayFieldName(translation[this.languages[0].code])">
                                {{ translation[this.languages[0].code].fieldId}}
                            </span>
                        </div>
                        <div *ngIf="!displayGlobalFields(translation[this.languages[0].code]) && authVisibility"
                            class="flex-1 text-left align-items-start d-flex flex-column justify-content-center">
                        </div>
                        <div *ngIf="displayGlobalFields(translation[this.languages[0].code]) && authVisibility"
                            class="flex-1 text-left align-items-start d-flex flex-column justify-content-around pr-4">
                            <ng-container *ngIf="translation[this.languages[0].code].type !== 'STATISTICS'">
                                <div *ngIf="this.isTranslationManager" class="my-1">
                                    <toggle-switch [toggled]="translation[this.languages[0].code].localAuthorized"
                                        (toggledChange)="translation[this.languages[0].code].localAuthorized = $event; saveSetting('localAuthorized', $event, translation);"
                                        [label]="'Authorize local' | translate"
                                        [tooltip]="localesInfos(translation[this.languages[0].code])"></toggle-switch>
                                </div>
                                <div *ngIf="!this.isTranslationManager" class="my-1">
                                    <toggle-switch [toggled]="translation[this.languages[0].code].localAuthorized"
                                        [label]="'Authorize local' | translate"
                                        [tooltip]="localesInfos(translation[this.languages[0].code])"
                                        [disabled]="true"></toggle-switch>
                                </div>
                                <div *ngIf="this.isTranslationManager && translation[this.languages[0].code].localAuthorized"
                                    class="my-1">
                                    <toggle-switch [toggled]="translation[this.languages[0].code].localSupersedesGlobal"
                                        (toggledChange)="translation[this.languages[0].code].localSupersedesGlobal = $event; saveSetting('localSupersedesGlobal', $event, translation);"
                                        [label]="'Local supersedes Global' | translate"
                                        [tooltip]="supersedeInfos(translation[this.languages[0].code])"></toggle-switch>
                                </div>
                                <div *ngIf="!this.isTranslationManager && translation[this.languages[0].code].localAuthorized"
                                    class="my-1">
                                    <toggle-switch [toggled]="translation[this.languages[0].code].localSupersedesGlobal"
                                        [label]="'Local supersedes Global' | translate"
                                        [tooltip]="supersedeInfos(translation[this.languages[0].code])"
                                        [disabled]="true"></toggle-switch>
                                </div>
                            </ng-container>
                        </div>
                        <div class="flex-7">
                            <div class="d-flex h-100 column-gap-1">
                                <div class="translation-field-container" *ngFor="let lnT of this.languages; index as i">
                                    <div class="translate-input flex-grow-1"
                                        *ngIf="(translation[lnT.code].localAuthorized || !displayGlobalFields(translation[lnT.code])) && translation[this.languages[0].code].type !== 'STATISTICS'">
                                        <span class="translation-legend d-flex align-items-center" *ngIf="i === 0"><i
                                                class="fas fa-l"></i></span>
                                        <textarea *ngIf="this.isLocalTranslator || !!translation[lnT.code].serviceId"
                                            class="form-control input-local translation-field"
                                            [(ngModel)]="translation[lnT.code].localName"
                                            (blur)="saveTranslation(translation[lnT.code])"></textarea>
                                        <textarea *ngIf="!this.isLocalTranslator && !translation[lnT.code].serviceId"
                                            class="form-control input-local translation-field"
                                            [(ngModel)]="translation[lnT.code].localName" disabled></textarea>
                                    </div>
                                    <div class="translate-input flex-grow-1"
                                        *ngIf="displayGlobalFields(translation[lnT.code])">
                                        <span class="translation-legend d-flex align-items-center" *ngIf="i === 0"><i
                                                class="fas fa-g"></i></span>
                                        <textarea *ngIf="this.isGlobalTranslator"
                                            class="form-control input-global translation-field"
                                            [(ngModel)]="translation[lnT.code].globalName"
                                            [attr.sort-value]="translation.key"
                                            (blur)="onGlobalTranslationsChange(translation[lnT.code])"></textarea>
                                        <textarea *ngIf="!this.isGlobalTranslator"
                                            class="form-control input-global translation-field"
                                            [(ngModel)]="translation[lnT.code].globalName"
                                            [attr.sort-value]="translation.key" disabled></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="action-col flex-1">
                            <i *ngIf="displayDeleteBtn(translation) || displayGlobalDeleteBtn(translation)"
                                (click)="setTranslationToDelete(translation, i)" class="fas fa-times">
                            </i>
                        </div>
                    </div>
                </div>
                <div class="app-pagination">
                    <ul class="pagination">
                        <li class="page-item" *ngIf="page > 1">
                            <a class="page-link" (click)="loadTranslations(currentLanguage, selectedService, 1)">
                                <i class="fal fa-angle-double-left"></i>
                            </a>
                        </li>
                        <li class="page-item" *ngIf="page > 1">
                            <a class="page-link"
                                (click)="loadTranslations(currentLanguage, selectedService, (page - 1))">
                                <i class="fal fa-angle-left"></i>
                            </a>
                        </li>
                        <li *ngFor="let p of pageNumber()" class="page-item" [ngClass]="{'hidden': (p !== page)}">
                            <span class="page-link disabled" disabled>
                                <b>{{p}}</b> of {{pageNumber()[(pageNumber().length - 1)]}}
                            </span>
                        </li>
                        <li class="page-item" *ngIf="page <= (pageNumber().length-1)">
                            <a class="page-link"
                                (click)="loadTranslations(currentLanguage, selectedService, (page + 1))">
                                <i class="fal fa-angle-right"></i>
                            </a>
                        </li>
                        <li class="page-item" *ngIf="page <= pageNumber()[(pageNumber().length - 2)]">
                            <a class="page-link"
                                (click)="loadTranslations(currentLanguage, selectedService, pageNumber()[(pageNumber().length - 1)])">
                                <i class="fal fa-angle-double-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <modal [show]="confirmDeletation" (onClose)="cancelDeletion()" [showClose]="false"
        class="modal-dialog-container confirmation-dialog">
        <div class="modal-body" *ngIf="selectedTranslation">
            <h4 class="confirmation-dialog-heading">{{ 'general.confirm' | translate }}</h4>
            <div class="confirmation-modal-body">{{'You are about to delete' | translate}}
                <b>{{selectedTranslation.name}}</b>
            </div>
            <div class="text-center mt-3">
                <primary-text-button *ngIf="displayDeleteBtn(selectedTranslation) && selectedTranslationIndex > -1"
                    [noLeftPadding]="true" (click)="deleteTranslation(selectedTranslation, selectedTranslationIndex)">
                    {{'recoverable delete' | translate }}
                </primary-text-button>
                <primary-text-button
                    *ngIf="displayGlobalDeleteBtn(selectedTranslation) && selectedTranslationIndex > -1"
                    [noLeftPadding]="true" [buttonClass]="'btn-danger'"
                    (click)="deleteGlobalTranslation(selectedTranslation, selectedTranslationIndex)">
                    {{'unrecoverable delete' | translate }}
                </primary-text-button>
                <cancelary-text-button (click)="cancelDeletion()">
                    {{'cancel' | translate }}
                </cancelary-text-button>
            </div>
        </div>
    </modal>
</app-wrapper>